import React, { useState, useEffect } from "react";
import {
   Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  FormControlLabel,
  Switch,
  Divider,
} from "@mui/material";
import { ThemeProvider } from "../../v2/home/theme/ThemeProvider";
import EscalatorIcon from "@mui/icons-material/Escalator";
import {Link} from "react-router-dom";
import AxiosInstance from "../../../services/AxiosInstance";
import {  
  USERS_BY_FUNCTIONAL_ROLE, ESCALATION_URL, ESCALATION_UPDATE_URL, ESCALATION_BY_SLA_URL
} from "../../../Constants/Constants";
import { ROLE_LEVEL, ROLE_MANAGER } from "../../../Constants/RolesConstants";
import { useAlert } from "./../../alerts/AlertContext";

export default function EscalationDialog({ slaId }) {
  const showAlert = useAlert();
  const [percent, setPercent] = useState("");

  const [open, setOpen] = React.useState(false);

  const [managers, setManagers] = React.useState([]);

  const [escalation, setEscalation] = useState({
    id: "",
    levelOneEnable: "",
    levelOnePercent: "",
    levelOneUser: {},
    levelTwoEnable: "",
    levelTwoPercent: "",
    levelTwoUser: {},
    sla:{}
  });

  useEffect(() => {
    getManagers();     
  }, []);

  const [level1, setLevel1] = useState({
    enabled: true,
    percent: 50,
    userId: "",
  });

  const [level2, setLevel2] = useState({
    enabled: false,
    percent: 75,
    userId: "",
  });

  const getManagers = async () => {
    await AxiosInstance.get(USERS_BY_FUNCTIONAL_ROLE + ROLE_LEVEL[ROLE_MANAGER]).then((response) => {
      setManagers(response.data);
    });
  };

  const getEscalationBySla = async () => {
    await AxiosInstance.get(ESCALATION_BY_SLA_URL + slaId).then((response) => {
      //setManagers(response.data);
      var esc = response.data;
      setEscalation({id: esc.id,
        levelOneEnable: esc.levelOneEnable,
        levelOnePercent: esc.levelOnePercent,
        levelOneUser: {id:esc.levelOneUser},
        levelTwoEnable: esc.levelTwoEnable,
        levelTwoPercent: esc.levelTwoPercent,
        levelTwoUser: {id:esc.levelTwoUser},
        sla:{id:esc.slaId}
      });
        
      setLevel1({enabled:esc.levelOneEnable, percent:esc.levelOnePercent, userId:esc.levelOneUser});
      setLevel2({enabled:esc.levelTwoEnable, percent:esc.levelTwoPercent, userId:esc.levelTwoUser});
    }).catch((error) => {
        //showAlert("Record not found!", "error");
        
        console.error(error);
      });
  };

  const handleSave = async () => {
    escalation.levelOneEnable = level1.enabled;
    escalation.levelOnePercent = Number(level1.percent);
    escalation.levelOneUser = {id:level1.userId};
    escalation.levelTwoEnable = level2.enabled;
    escalation.levelTwoPercent = Number(level2.percent);
    escalation.levelTwoUser = {id:level2.userId};
    escalation.sla = {id:slaId};
    
     await AxiosInstance.post(escalation.id === "" ? ESCALATION_URL : ESCALATION_UPDATE_URL, escalation)
     //await AxiosInstance.post(ESCALATION_URL , escalation)
      //await AxiosInstance.post(ROLES_URL, role)
      .then((response) => {
        if (escalation.id === "") showAlert("Escalation created successfully!", "success");
        else showAlert("Escalation updated successfully!", "success");        
      })
      .catch((error) => {
        showAlert("Escalation creation failed!", "error");
        console.error(error);
      });
      handleClose();
  };

  const handleClickOpen = () => {
    getEscalationBySla();
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };


  return (
    <ThemeProvider>
      <React.Fragment>
        <Link onClick={handleClickOpen}>{<EscalatorIcon />}</Link>
         <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <DialogTitle>Set Escalation Rules</DialogTitle>
      <DialogContent dividers>
        {/* Level 1 */}
        <FormControlLabel
          control={
            <Switch
              checked={level1.enabled}
              onChange={(e) =>
                setLevel1({ ...level1, enabled: e.target.checked })
              }
            />
          }
          label="Enable Level 1 Escalation"
        />
        {level1.enabled && (
          <>
            <TextField
              fullWidth
              type="number"
              label="Escalation % of SLA"
              margin="normal"
              value={level1.percent}
              onChange={(e) =>
                setLevel1({ ...level1, percent: e.target.value })
              }
              inputProps={{ min: 1, max: 100 }}
            />
             <TextField
              select
              fullWidth
              label="Escalate To User"
              margin="normal"
              value={level1.userId}
              onChange={(e) =>
                setLevel1({ ...level1, userId: e.target.value })
              }
            >
              {managers != null && managers.map((m) => (
                <MenuItem key={m.userId} value={m.userId}>
                  {m.userName}
                </MenuItem>
              ))}
            </TextField> 
          </>
        )}

        <Divider sx={{ my: 2 }} />

        {/* Level 2 */}
        <FormControlLabel
          control={
            <Switch
              checked={level2.enabled}
              onChange={(e) =>
                setLevel2({ ...level2, enabled: e.target.checked })
              }
            />
          }
          label="Enable Level 2 Escalation"
        />
        {level2.enabled && (
          <>
            <TextField
              fullWidth
              type="number"
              label="Escalation % of SLA"
              margin="normal"
              value={level2.percent}
              onChange={(e) =>
                setLevel2({ ...level2, percent: e.target.value })
              }
              inputProps={{ min: 1, max: 100 }}
            />
            <TextField
              select
              fullWidth
              label="Escalate To User"
              margin="normal"
              value={level2.userId}
              onChange={(e) =>
                setLevel2({ ...level2, userId: e.target.value })
              }
            >
              {managers != null && managers.map((m) => (
                <MenuItem key={m.userId} value={m.userId}>
                  {m.userName}
                </MenuItem>
              ))}
            </TextField>
          </>
        )}
      </DialogContent>

      <DialogActions>
        <Button onClick={handleClose} color="secondary">
          Close
        </Button>
        <Button onClick={handleSave} variant="contained" color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
      </React.Fragment>
    </ThemeProvider>
  );
}
